export default {
    defaultMemberRole: {
        bannerMessage: `Self sign-up requires a Default Member Role. We'll add a Default Member Role you can edit at anytime.`,
        bannerAction: `Create role here`,
        modalTitle: `We'll create a Default Member Role for you`,
        modalBody: `Members who sign themselves up need a role assigned automatically, so we'll add a Default Member role to your roles list with basic access — members can view and update their own profile, and nothing else. You can edit this in Default Access Settings.`,
        modalCancel: `No, Cancel`,
        modalConfirm: `Yes, create role`,
        createSuccess: `Default member role created successfully.`,
        createError: `Something went wrong creating the role. Please try again.`
    }
}
